import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { fmtEur, fmtHours } from "@/lib/reports";
import { Panel, SectionLabel } from "@/components/common/ui-kit";
import { ReportRow } from "@/components/reports/ReportRow";

const Kpi = ({ l, v, testId }) => <div data-testid={testId}><p className="text-[11px] font-medium text-slate-400">{l}</p><p className="mt-0.5 text-lg font-semibold text-ink">{v}</p></div>;

export const CompanyEconomics = ({ companyId }) => {
  const [e, setE] = useState(null);
  useEffect(() => { api.get(`/companies/${companyId}/economics`).then((r) => setE(r.data)).catch(() => {}); }, [companyId]);
  if (!e) return null;
  return (
    <Panel className="grid grid-cols-2 gap-4 p-5 md:grid-cols-5" data-testid="company-economics">
      <Kpi l="Ore residue pacchetti" v={fmtHours(e.hours_remaining)} testId="eco-hours" /><Kpi l="Valore residuo pacchetti" v={fmtEur(e.value_remaining)} testId="eco-value" />
      <Kpi l="Imponibile rapportini" v={fmtEur(e.taxable)} /><Kpi l="Coperto da pacchetti" v={fmtEur(e.package_covered)} /><Kpi l="Da fatturare" v={fmtEur(e.to_invoice)} testId="eco-to-invoice" />
    </Panel>
  );
};

export const CompanyReportsTab = ({ company }) => {
  const { can } = useAuth();
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/service-reports", { params: { company_id: company.id, limit: 100 } }).then((r) => setItems(r.data.items)).catch(() => setItems([])); }, [company.id]);
  return (
    <div className="space-y-5" data-testid="company-reports-tab">
      {can("reports:economics") && <CompanyEconomics companyId={company.id} />}
      <Panel className="p-5"><SectionLabel>Rapportini</SectionLabel>
        {items && !items.length && <p className="mt-2 text-sm text-slate-500">Nessun rapportino per questo cliente.</p>}
        <ul className="divide-y divide-line">{(items || []).map((r) => <ReportRow key={r.id} rep={r} showCompany={false} />)}</ul></Panel>
    </div>
  );
};
